// @flow
import { Icon } from 'semantic-ui-react';
import React from 'react';

export const RefreshIcon = ({ onClick }) => (
  <Icon name="sync alternate" onClick={onClick} style={{ cursor: 'pointer' }} />
);
